import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.tasks.loaded,
    props.lootbox.loaded,
    props.user.user,
    (tasks_loaded, lootbox_loaded, user) => {
        return {
            loaded: tasks_loaded && lootbox_loaded,
            tasks_loaded,
            lootbox_loaded,
            user
        }
    }
)